var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDateTimeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F8F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7539 17.6953H16.1307V20.0721H13.7539V17.6953ZM13.7539 22.449H16.1307V24.8258H13.7539V22.449ZM18.5076 17.6953H20.8844V20.0721H18.5076V17.6953ZM18.5076 22.449H20.8844V24.8258H18.5076V22.449ZM23.2612 17.6953H25.638V20.0721H23.2612V17.6953ZM23.2612 22.449H25.638V24.8258H23.2612V22.449Z",
    fill: "#3659E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.45 30.7683H11.3768C10.066 30.7683 9 29.7023 9 28.3914V11.7537C9 10.4428 10.066 9.37683 11.3768 9.37683H13.7537V7H16.1305V9.37683H23.261V7H25.6378V9.37683H28.0146C29.3254 9.37683 30.3915 10.4428 30.3915 11.7537V24.2317H28.0155L28.0146 14.1305H11.3768V28.3914H24.45V30.7683Z",
    fill: "#3659E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2024 24.8271C26.9475 24.8271 25.043 26.7317 25.043 28.9866C25.043 31.2415 26.9475 33.146 29.2024 33.146C31.4573 33.146 33.3619 31.2415 33.3619 28.9866C33.3619 26.7317 31.4573 24.8271 29.2024 24.8271ZM29.2024 32.2217C27.449 32.2217 25.9673 30.74 25.9673 28.9866C25.9673 27.2332 27.449 25.7515 29.2024 25.7515C30.9559 25.7515 32.4375 27.2332 32.4375 28.9866C32.4375 30.74 30.9559 32.2217 29.2024 32.2217Z",
    fill: "#3659E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2036 28.9863V27.1377H28.2793V29.9107H31.0523V28.9863H29.2036Z",
    fill: "#3659E3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateTimeIcon);
export default __webpack_public_path__ + "static/media/dateTimeIcon.93e14d217ad9f7b9568bc4e3dd357134.svg";
export { ForwardRef as ReactComponent };